import React, { FC } from 'react';

import InfiniteScrollSelect from '@ui/InfiniteScrollSelect';
import FormFieldWrapper from '../Wrapper';
import { IInfiniteScrollSelectFormFieldProps } from './interfaces';

const InfiniteScrollSelectField: FC<IInfiniteScrollSelectFormFieldProps> = ({
  name,
  label,
  children,
  ...props
}) => {
  return (
    <FormFieldWrapper
      name={name}
      label={label}
      render={fieldProps => (
        <InfiniteScrollSelect {...props} {...fieldProps}>
          {children}
        </InfiniteScrollSelect>
      )}
    />
  );
};

export default InfiniteScrollSelectField;
